import Vue from "vue";
import VueRouter from "vue-router";
// h5 Page
import h5Home from "../views/mainHome.vue";
import registerInfo from "../views/registerInfo.vue";
import faceIdentify from "../views/faceIdentify.vue";
import historyList from "../views/historyList.vue";
import couponList from "../views/couponList.vue";
import placingPage from "../views/h5Components/placingPage.vue";
import placingPageJG from "../views/h5Components/placingPageJG.vue";

// web Page
import webHome from "../views/webPage/home.vue";
import registerInfoWeb from "../views/webPage/registerInfo.vue";
import faceIdentifyWeb from "../views/webPage/faceIdentify.vue";
import historyListWeb from "../views/webPage/historyList.vue";
import couponListWeb from "../views/webPage/couponList.vue";

Vue.use(VueRouter);

const routes = [
  // h5页面
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: h5Home,
  },
  {
    path: "/registerInfo",
    name: "registerInfo",
    component: registerInfo,
  },
  {
    path: "/faceIdentify",
    name: "faceIdentify",
    component: faceIdentify,
  },
  {
    path: "/historyList",
    name: "historyList",
    component: historyList,
  },
  {
    path: "/placingPage",
    name: "placingPage",
    component: placingPage,
  },
  {
    path: "/placingPageJG",
    name: "placingPageJG",
    component: placingPageJG,
  },
  {
    path: "/couponList",
    name: "couponList",
    component: couponList,
  },
  // web页面
  {
    path: "/homeWeb",
    name: "homeWeb",
    component: webHome,
  },
  {
    path: "/registerInfoWeb",
    name: "registerInfoWeb",
    component: registerInfoWeb,
  },
  {
    path: "/faceIdentifyWeb",
    name: "faceIdentifyWeb",
    component: faceIdentifyWeb,
  },
  {
    path: "/historyListWeb",
    name: "historyListWeb",
    component: historyListWeb,
  },
  {
    path: "/couponListWeb",
    name: "couponListWeb",
    component: couponListWeb,
  },
];

const router = new VueRouter({
  mode: window.location.host == "www.mastersol.tech" ? "history" : "hash",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes,
  // 滚动行为配置
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    // return { top: 0 };

    // 或兼容旧版写法
    return { x: 0, y: 0 }
  },
});

export default router;
